import { handleResponse } from './handleResponse';
import {
  AuthToken,
  UserAuth,
  UserRegistrationData,
  VerificationResponse,
} from '../types/user';
import apiAxios, { authAxios } from './apiAxios';

const BASE_ROUTE_V2 = '/api/v2/auth';

const authApi = {
  async requestVerification(
    phoneNumber: string,
    alwaysSend?: boolean
  ): Promise<VerificationResponse> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/code/request`, { phoneNumber, alwaysSend })
      .then(handleResponse);
  },
  async verifyCode(
    phoneNumber: string,
    verificationCode: string
  ): Promise<{ registered: boolean }> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/code/verify`, {
        phoneNumber,
        code: verificationCode,
      })
      .then(handleResponse);
  },
  async login(phoneNumber: string, password: string): Promise<UserAuth> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/login`, { phoneNumber, password })
      .then(handleResponse);
  },
  async refreshToken(refreshToken: string): Promise<AuthToken> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/refresh`, { token: refreshToken })
      .then(handleResponse);
  },
  async register(data: UserRegistrationData): Promise<UserAuth> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/register`, data)
      .then(handleResponse);
  },
  async setPassword(data: {
    code: string;
    phoneNumber: string;
    password: string;
  }): Promise<UserAuth> {
    return authAxios
      .post(`${BASE_ROUTE_V2}/password`, data)
      .then(handleResponse);
  },
  async changePassword(data: {
    current: string;
    password: string;
  }): Promise<AuthToken> {
    return apiAxios.put(`${BASE_ROUTE_V2}/password`, data).then(handleResponse);
  },
};

export default authApi;
